module.exports = __webpack_public_path__ + "img/Monte_Kope_93.88a453a9.jpg";